"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ModelVisibilitiesController", {
    enumerable: true,
    get: function() {
        return ModelVisibilitiesController;
    }
});
const _common = require("@nestjs/common");
const _globalguard = require("~/guards/global/global.guard");
const _modelvisibilitiesservice = require("~/services/model-visibilities.service");
const _extractidsmiddleware = require("~/middlewares/extract-ids/extract-ids.middleware");
const _metaapilimiterguard = require("~/guards/meta-api-limiter.guard");
const _tenantcontextdecorator = require("~/decorators/tenant-context.decorator");
const _config = require("~/interface/config");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
function _ts_param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
let ModelVisibilitiesController = class ModelVisibilitiesController {
    async xcVisibilityMetaSetAll(context, baseId, body, req) {
        await this.modelVisibilitiesService.xcVisibilityMetaSetAll(context, {
            visibilityRule: body,
            baseId,
            req
        });
        return {
            msg: 'UI ACL has been created successfully'
        };
    }
    async modelVisibilityList(context, baseId, includeM2M) {
        return await this.modelVisibilitiesService.xcVisibilityMetaGet(context, {
            baseId,
            includeM2M: includeM2M === true || includeM2M === 'true'
        });
    }
    constructor(modelVisibilitiesService){
        this.modelVisibilitiesService = modelVisibilitiesService;
    }
};
_ts_decorate([
    (0, _common.Post)([
        '/api/v1/db/meta/projects/:baseId/visibility-rules',
        '/api/v2/meta/bases/:baseId/visibility-rules'
    ]),
    (0, _common.HttpCode)(200),
    (0, _extractidsmiddleware.Acl)('modelVisibilitySet'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('baseId')),
    _ts_param(2, (0, _common.Body)()),
    _ts_param(3, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        Object,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], ModelVisibilitiesController.prototype, "xcVisibilityMetaSetAll", null);
_ts_decorate([
    (0, _common.Get)([
        '/api/v1/db/meta/projects/:baseId/visibility-rules',
        '/api/v2/meta/bases/:baseId/visibility-rules'
    ]),
    (0, _extractidsmiddleware.Acl)('modelVisibilityList'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('baseId')),
    _ts_param(2, (0, _common.Query)('includeM2M')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        Object
    ]),
    _ts_metadata("design:returntype", Promise)
], ModelVisibilitiesController.prototype, "modelVisibilityList", null);
ModelVisibilitiesController = _ts_decorate([
    (0, _common.Controller)(),
    (0, _common.UseGuards)(_metaapilimiterguard.MetaApiLimiterGuard, _globalguard.GlobalGuard),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _modelvisibilitiesservice.ModelVisibilitiesService === "undefined" ? Object : _modelvisibilitiesservice.ModelVisibilitiesService
    ])
], ModelVisibilitiesController);
